import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import { closeIcon } from "assets/icons/importIcon";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import StepDot from "components/Base/StepDot";
import AppHelper from "helpers/AppHelper";
import { MINUTES, HOURS, SERVINGS } from "constants/add-recipe.constants";
import { createRecipe } from "actions/recipe";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from 'lodash'

const CreateRecipe = React.forwardRef((props: any, ref: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isEdit, itemEdit, brikId, subId, sectionId, lastContentOrder, isCreate, isDuplicate } = props;
  const {
    control,
    watch,
    setValue,
    getValues,
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors
  } = useForm({
    mode: "onSubmit"
  });

  const [recipeName, setRecipeName] = useState<string>('');
  const [recipeDesc, setRecipeDesc] = useState<string>('');
  const [errorRecipeName, setErrorRecipeName] = useState(false);
  const [errorRecipeDesc, setErrorRecipeDesc] = useState(false);
  const [prepHours, setPrepHours] = useState(HOURS[0].value);
  const [prepMinutes, setPrepMinutes] = useState(MINUTES[0].value);
  const [cookHours, setCookHours] = useState(HOURS[0].value);
  const [cookMinutes, setCookMinutes] = useState(MINUTES[0].value);
  const [servings, setServings] = useState(SERVINGS[0].value);

  const [urlVideoRecipe, setUrlVideoRecipe] = useState<string>('');
  const [recipeImage, setRecipeImage] = useState<any>(null);

  const [listIngredients, setListIngredients] = useState<any>([{ content: "", order: 0, id: `delete.1` }]);
  const [listInstructions, setListInstructions] = useState<any>([{ content: "", order: 0, id: `delete.1` }]);

  const [index, setIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [editRecipe, setEditRecipe] = useState(false)
  const [isChangeImage, setIsChangeImage] = useState(false)
  const pages = [
    { subTitle: "Enter in the below info to create a new recipe." },
    { subTitle: "Upload an image or video." },
    { subTitle: "Enter in the ingredients." },
    { subTitle: "Enter in the instructions." },
  ];

  const [itemEditState, setItemEditState] = useState(itemEdit || []);
  const { detailRecipe } = useSelector((state: any) => state.recipe);

  useEffect(() => {
    if (itemEdit) {
      const cloneListIngredients = _.cloneDeep(itemEdit?.ingredient);
      const sortListIngredients = cloneListIngredients.sort(
        (item1: any, item2: any) => {
          return item1.order - item2.order;
        }
      );
      setListIngredients(sortListIngredients);

      const cloneListInstructions = _.cloneDeep(itemEdit?.instruction);
      const sortListInstructions = cloneListInstructions.sort((item1: any, item2: any) => {
        return item1.order - item2.order;
      })
      setListInstructions(sortListInstructions)
    }
    setItemEditState(itemEdit);
  }, [itemEdit]);

  useEffect(() => {
    if (detailRecipe?.id === itemEdit?.id) {
      setItemEditState(detailRecipe);
    }
  }, [detailRecipe]);

  const onChangeImage = (image: any) => {
    let itemStep2: any = _.clone(itemEditState);
    itemStep2.image = image;
    setItemEditState(itemStep2);
  }

  const onChangeUrl = (url: any) => {
    let itemStep2: any = _.clone(itemEditState);
    itemStep2.url = url;
    setItemEditState(itemStep2);
  }

  const onHandleCloseModal = () => {
    AppHelper.hideGlobalModal();
    if (!isEdit && !isCreate && !isDuplicate) {
      AppHelper.showListRecipe({ brikId, sectionId, subId, lastContentOrder });
    }
  };

  const onBackClick = () => {
    setPrevIndex(index);
    setIndex(index - 1);
  };

  const onNextClick = () => {
    setPrevIndex(index);
    setIndex(index + 1);
  };

  const handleCreateRecipe = async () => {
    try {
      await dispatch(createRecipe({
        name: recipeName,
        description: recipeDesc,
        servings: servings,
        prep_hours: prepHours,
        prep_minutes: prepMinutes,
        cook_hours: cookHours,
        cook_minutes: cookMinutes,
        url: urlVideoRecipe,
        image: recipeImage?.includes("https") ? recipeImage.replace(process.env.REACT_APP_STORAGE_DOMAIN, "") : recipeImage,
        ingredients: listIngredients,
        instructions: listInstructions,
      }));
    }catch(err) {
      await dispatch(createRecipe({
        name: recipeName,
        description: recipeDesc,
        servings: servings,
        prep_hours: prepHours,
        prep_minutes: prepMinutes,
        cook_hours: cookHours,
        cook_minutes: cookMinutes,
        url: urlVideoRecipe,
        image: recipeImage,
        ingredients: listIngredients,
        instructions: listInstructions,
      }));
    }
  }

  const renderContent = () => {
    switch (index) {
      case 0:
        return (
          <Step1
            onNextClick={onNextClick}
            getValues={getValues}
            setValue={setValue}
            register={register}
            handleSubmit={handleSubmit}
            errors={errors}
            control={control}
            watch={watch}
            onHandleCloseModal={onHandleCloseModal}
            recipeName={recipeName}
            setRecipeName={setRecipeName}
            recipeDesc={recipeDesc}
            setRecipeDesc={setRecipeDesc}
            prepHours={prepHours}
            setPrepHours={setPrepHours}
            prepMinutes={prepMinutes}
            setPrepMinutes={setPrepMinutes}
            cookHours={cookHours}
            setCookHours={setCookHours}
            cookMinutes={cookMinutes}
            setCookMinutes={setCookMinutes}
            servings={servings}
            setServings={setServings}
            isEdit={isEdit}
            itemEdit={itemEditState}
            setEditRecipe={setEditRecipe}
            errorRecipeName={errorRecipeName}
            setErrorRecipeName={setErrorRecipeName}
            errorRecipeDesc={errorRecipeDesc}
            setErrorRecipeDesc={setErrorRecipeDesc}
            setItemEditState={setItemEditState}
          />
        );
      case 1:
        return (
          <Step2
            onNextClick={onNextClick}
            onBackClick={onBackClick}
            getValues={getValues}
            setValue={setValue}
            register={register}
            handleSubmit={handleSubmit}
            errors={errors}
            onHandleCloseModal={onHandleCloseModal}
            urlVideoRecipe={urlVideoRecipe}
            setUrlVideoRecipe={setUrlVideoRecipe}
            recipeImage={recipeImage}
            setRecipeImage={setRecipeImage}
            isEdit={isEdit}
            itemEdit={itemEditState}
            recipeName={recipeName}
            recipeDesc={recipeDesc}
            prepHours={prepHours}
            prepMinutes={prepMinutes}
            cookHours={cookHours}
            cookMinutes={cookMinutes}
            servings={servings}
            brikId={brikId}
            editRecipe={editRecipe}
            setEditRecipe={setEditRecipe}
            onChangeImage={onChangeImage}
            onChangeUrl={onChangeUrl}
            setIsChangeImage={setIsChangeImage}
          />
        );
      case 2:
        return (
          <Step3
            onNextClick={onNextClick}
            onBackClick={onBackClick}
            getValues={getValues}
            setValue={setValue}
            register={register}
            handleSubmit={handleSubmit}
            errors={errors}
            onHandleCloseModal={onHandleCloseModal}
            listIngredients={listIngredients}
            setListIngredients={setListIngredients}
            isEdit={isEdit}
            itemEdit={itemEdit}
            setError={setError}
            setEditRecipe={setEditRecipe}
            clearErrors={clearErrors}
          />
        );
      case 3:
        return (
          <Step4
            onBackClick={onBackClick}
            getValues={getValues}
            setValue={setValue}
            register={register}
            handleSubmit={handleSubmit}
            errors={errors}
            onHandleCloseModal={onHandleCloseModal}
            listInstructions={listInstructions}
            setListInstructions={setListInstructions}
            handleCreateRecipe={handleCreateRecipe}
            isEdit={isEdit}
            isDuplicate={isDuplicate}
            editRecipe={editRecipe}
            itemEdit={itemEdit}
            itemEditState={itemEditState}
            isChangeImage={isChangeImage}
            setEditRecipe={setEditRecipe}
            setError={setError}
            clearErrors={clearErrors}
            listIngredients={listIngredients}
            brikId={brikId}
          />
        );
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerModal} style={{ boxShadow: "1px 1px 6px rgba(56, 25, 81, 0.25)" }}>
        <div className={classes.titleModal}>
          <p>{isEdit ? `Editing ${itemEdit?.name}` : isDuplicate ? `Duplicate ${itemEdit?.name}` : 'Create a new recipe'}</p>
          <p>{isEdit ? 'Update the below info to edit the recipe.' : pages[index]?.subTitle}</p>
        </div>
        <StepDot
          prevDot={prevIndex}
          totalDot={pages.length}
          selectDot={index}
          withoutLine={true}
          customClass={classes.customDot}
        />
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              cursor: "pointer",
            }}
          >
            <img src={closeIcon} alt="" onClick={onHandleCloseModal} style={{ padding: '0 0 15px 15px' }} />
          </div>
        </div>
      </div>
      <div className={classes.bodyModalList}>{renderContent()}</div>
    </div>
  );
});

export default CreateRecipe;
